import React from 'react'
import Table from 'react-bootstrap/Table';

const ReferenceBuildingDetails = (props) => {
    return (
        <Table striped bordered hover size="sm">
  <thead>
    <tr>
      <th>&Ucirc;<br />(W/m<sup>2</sup>K)</th>
      <th>Compactness<br />(m)</th>
      <th>U<sub>w</sub><br />(W/m<sup>2</sup>K)</th>
      <th>Windows per Wall<br />Orientation<br />(%)</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td>{props.u}</td>
      <td>{props.compactness}</td>
      <td>{props.u_w}</td>
      <td>{props.windows_per_wall_orientation}</td>
    </tr>
  </tbody>
</Table>
    );
}

export default ReferenceBuildingDetails